<template>
  <LazyCalendarFilterDropdown
    ref="select"
    :value="currentAirportText"
    :is-active="currentAirport"
    :label="$t('calendar.chooseAirport')"
    label-i18n="calendar.chooseAirport"
    icon="plane"
  >
    <div class="w-full py-2 bg-white">
      <button
        v-if="hasAirportAllOption"
        class="dropdown-item"
        type="button"
        @click="selectAirport(null)"
      >
        {{ $t('allAirports') }}
      </button>
      <button
        v-for="({ name, iata }, i) in airportList"
        :key="i"
        class="dropdown-item"
        type="button"
        @click="selectAirport(iata)"
      >
        <span>
          {{ name }}
        </span>
      </button>
    </div>
  </LazyCalendarFilterDropdown>
</template>

<script>
import events from '@layers/web/constants/events.js'

export default defineNuxtComponent({
  props: {
    airports: {
      type: Array,
      default: () => [],
    },

    prefilledAirportIata: {
      type: String,
      default: null,
    },

    hasAirportAllOption: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['update', events.selectedAirport],

  data () {
    return {
      selectedAirport: null,
    }
  },

  watch: {
    prefilledAirportIata (value) {
      this.selectedAirport = value
    },
  },

  computed: {
    wrapper () {
      return {
        currentAirport: this.currentAirport,
        airports: this.airportList,
        findAirport: this.findAirportByIata,
        select: this.selectAirport,
      }
    },

    currentAirport () {
      return this.findAirportByIata(this.selectedAirport)
    },

    currentAirportText () {
      return this.currentAirport ? this.currentAirport.name : this.$t('allAirports')
    },

    airportList () {
      return (this.airports || []).filter(airport => airport?.iata)
    },
  },

  mounted () {
    if (this.prefilledAirportIata) {
      this.selectedAirport = this.prefilledAirportIata
    }
  },

  methods: {
    hide () {
      this.$refs?.select?.hide()
    },

    findAirportByIata (searchIata) {
      return this.airportList.find(({ iata }) => iata === searchIata)
    },

    selectAirport (value) {
      this.selectedAirport = value
      this.$emit('update', value)
      this.$event.$emit(events.selectedAirport, value)
    },
  },
})
</script>
